import { cn } from '@/platform/lib/utils';
import { Button as HeadlessButton } from '@headlessui/react';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { forwardRef } from 'react';

const variants = {
    primary:
        'bg-primary-600 text-white hover:bg-primary-700 focus-visible:outline-primary-600',
    default:
        'bg-white text-gray-700 outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus-visible:outline-gray-400',
    danger: 'bg-red-600 text-white hover:bg-red-500 focus-visible:outline-red-600',
    link: 'text-primary-600 hover:text-primary-700 focus-visible:outline-primary-600 rounded-sm p-0 font-medium',
};

const Button = forwardRef(function Button(
    {
        as,
        variant = 'default',
        loading = false,
        disabled = false,
        fluid = false,
        className,
        children,
        ...props
    },
    ref
) {
    return (
        <HeadlessButton
            ref={ref}
            as={as}
            disabled={disabled || loading}
            aria-busy={loading}
            className={cn(
                'inline-flex items-center justify-center gap-x-2 rounded-md px-3.5 py-2 text-sm font-semibold whitespace-nowrap transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-50',
                fluid && 'w-full',
                variants[variant] ?? variants.default,
                className
            )}
            {...props}
        >
            {loading && (
                <ArrowPathIcon
                    className='size-4 animate-spin'
                    aria-hidden='true'
                />
            )}
            {children}
        </HeadlessButton>
    );
});

export default Button;
